<template>
  <div>
    <div class="headline">You're ready to go!</div>

    <v-alert :value="saveErrors.length > 0">
      <ul>
        <li v-for="(error, ei) in saveErrors" v-bind:key="`e-${index}-${ei}`">
          {{ error }}
        </li>
      </ul>
    </v-alert>
    <v-btn color="primary" @click="save" :loading="saving">Save and Finish</v-btn>
    <v-btn flat @click="back" :disabled="saving">Back</v-btn>
  </div>
</template>
<script>
import moment from 'moment-timezone';
export default {
  props: ['next', 'back', 'context', 'save', 'saveErrors', 'saving'],
  data() {
    return {
      categorized: 5,
      total: 100,
      valid: true,
      // startDate: ""
    };
  },
  methods: {},
  computed: {
    dateMax() {
      const date = moment().format('L');
      const ret = moment.utc(date).hours(23).minutes(59).second(59);
      return ret.toISOString();
    },
  },
};
</script>
